// extracted by mini-css-extract-plugin
export default {"mainTumb":"Band_mainTumb__iUUhG"};